module.exports = __webpack_public_path__ + "img/kankou_12.7cc703b3.jpg";